import styled from "styled-components";
import { Col } from "components/common";

export const Wrapper = styled(Col)`

    .payee-payrol-pay-box {
        display: flex;
        flex: 1;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        background: white;
        border-radius: 5px;
        padding: 5px 15px;
        min-height: 50px;
        box-shadow: 1px 1px 10px #c6c6c6;

        .payee-payrol-pay-title {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            gap: 10px;

            .payee-payrol-pay-title-checkbox {

            }
            .payee-payrol-pay-title-text {
                font-size: ${props => props.isSmall ? "13px" : "15px"};
                color: #434343;
            }
        }

        .payee-payrol-pay-middle-container {
            .payee-payrol-pay-input {
                border: none;
                background: #e4e4e4;
                outline: none;
                text-align: center;
                width: 70px;
                height: 35px;
                border-radius: 5px;
                box-shadow: inset 0 0 5px #ababab;
            }
            .payee-payrol-pay-text-box {
                font-size: ${props => props.isSmall ? "13px" : "15px"};
                color: #434343;
                font-weight: bold;
            }
        }

        .payee-payrol-pay-bottom-container {
            display: flex;
            flex-direction: row;
            align-items: center;
            .payee-payrol-pay-amount {
                font-size: ${props => props.isSmall ? "14px" : "16px"};
                font-weight: 600;
                color: #434343;
            }
        }

        .payee-payrol-pay-amount {
            font-size: ${props => props.isSmall ? "14px" : "16px"};
            font-weight: 600;
            color: #434343;
        }
    }
    .payee-payrol-pay-multi-box {
        position: relative;
    }
    .payee-payrol-pay-option-div {
        position: absolute;
        z-index: 1;
        background: #131f28;
        width: 100%;
        padding: 10px;
        border-bottom-right-radius: 5px;
        border-bottom-left-radius: 5px;
        display: flex;
        flex-direction: column;
        gap: 10px;
        max-height: 130px;
        overflow-y: auto;
        animation: dropdownOpen 0.3s ease-in-out;
    }
    .no-shadow {
        box-shadow: none;
        max-height: 50px;
    }
    .cursor-pointer {
        cursor: pointer;
    }
    @keyframes dropdownOpen {
        0% {
          opacity: 0;
          transform: translateY(-10px);
        }
        100% {
          opacity: 1;
          transform: translateY(0);
        }
      }
`;